import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "user/store/useAuthStore";

type Props = {
    children: ReactNode;
    customerIdx: number | null;
    isUpdate: boolean;
};
// 주문 신청 중 새로고침시 페이지 이동
export default function RefreshRedirect({ children, customerIdx, isUpdate }: Props) {
    const user = useAuthStore(state => state);
    const isNonMember = user.m_category === null;
    const customer_idx = customerIdx;

    // 신규 주문 시
    if (!isUpdate) {
        // 비회원 새로 고침 대응
        if (isNonMember && !customer_idx) return <Navigate to={`/login-non-member`} replace />;
        // 회원 새로 고침 대응
        if (!isNonMember && !customer_idx) return <Navigate to={`/new-order`} replace />;
    }

    return <>{children}</>;
}
